import { useState } from "react";
import { useTranslation } from "react-i18next";
import lock from "../../../assets/images/icons/lock.svg";
import phone from "../../../assets/images/icons/phone-dark.svg";
import accountMinus from "../../../assets/images/icons/user-profile-minus.svg";
import ChangePasswordModal from "./ChangePasswordModal";
import ConfirmPasswordChangeNumber from "./ConfirmPasswordChangeNumberModal";
import DeactivateAccountModal from "./DeactivateAccountModal";

const AccountSetting = () => {
  const { t } = useTranslation();

  const [isChangePhoneNumberModalOpen, setIsChangePhoneNumberModalOpen] =
    useState(false);
  const [isDeactivateModalOpen, setIsDeactivateModalOpen] = useState(false);
  const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] =
    useState(false);

  const handleOpenChangePasswordModal = () => {
    setIsChangePasswordModalOpen(true);
  };

  const handleCloseChangePasswordModal = () => {
    setIsChangePasswordModalOpen(false);
  };

  return (
    <div>
      <div className="flex flex-col gap-2">
        <div
          className="flex cursor-pointer items-center gap-3 rounded-lg border bg-input-field p-3"
          onClick={handleOpenChangePasswordModal}
        >
          <img src={lock} className="h-5 w-5" alt="lock icon" />
          <h3 className="text-lg text-secondaryDark">{t("change_password")}</h3>
        </div>

        <div
          className="flex cursor-pointer items-center gap-3 rounded-lg border bg-input-field p-3"
          onClick={() => setIsChangePhoneNumberModalOpen(true)}
        >
          <img src={phone} className="h-5 w-5" alt="phone icon" />
          <h3 className="text-lg text-secondaryDark">{t("change_number")}</h3>
        </div>

        <div
          className="flex cursor-pointer items-center gap-3 rounded-lg border bg-input-field p-3"
          onClick={() => setIsDeactivateModalOpen(true)}
        >
          <img
            src={accountMinus}
            className="h-5 w-5"
            alt="account minus icon"
          />
          <h3 className="text-lg text-error">{t("delete_account")}</h3>
        </div>

        {/* <ExportPatientsReportButton /> */}
      </div>

      <ChangePasswordModal
        onClose={handleCloseChangePasswordModal}
        isChangePasswordModalOpen={isChangePasswordModalOpen}
      />

      <DeactivateAccountModal
        isOpen={isDeactivateModalOpen}
        onClose={() => setIsDeactivateModalOpen(false)}
      />

      <ConfirmPasswordChangeNumber
        isOpen={isChangePhoneNumberModalOpen}
        onClose={() => setIsChangePhoneNumberModalOpen(false)}
      />
    </div>
  );
};

export default AccountSetting;
